<template src="./template.html"></template>

<script>
export default {
  name: "HomeOriginStory",
  data() {
    return {}
  },
  methods: {}
}
</script>